import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { ListBulletContainer, ListBulletRow, ListBullet } from "./HXListBulletView.styles";
import { Text } from "./HXMobilePage.styles";
export const ListBulletView = (props) => {
    return (_jsx(ListBulletContainer, { children: props.list.map((item, index) => (_jsxs(ListBulletRow, { children: [_jsx(ListBullet, { color: props.color, alignStart: props.alignBulletStart, children: "\u2022" }), _jsx(Text, { color: props.color, children: item })] }, index))) }));
};
